<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Compose Email</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <!-- Page Title Header Starts-->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="content-header">
            <p>Click each option to compose email.</p>
            <mat-divider></mat-divider>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="email-menu">
            <mat-nav-list dense>
              <mat-list-item class="mat-list-item-selected">
                <mat-icon matListIcon>create</mat-icon>
                <a matLine routerLink="/compose-email">Compose</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>mail</mat-icon>
                <a matLine routerLink="/email">Inbox</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>send</mat-icon>
                <a matLine routerLink="/email">Sent</a>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListIcon>drafts</mat-icon>
                <a matLine routerLink="/read-email">Templates</a>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <div class="page-content">
            <mat-toolbar class="email-toolbar">
              <span>Compose Mail</span>
              <span class="example-spacer"></span>
              <button mat-icon-button class="example-icon" aria-label="view attachment" matTooltip="Cancel Email">
                <mat-icon>backspace</mat-icon>
              </button>
              <button mat-icon-button class="example-icon" aria-label="view attachment" matTooltip="Inbox">
                <mat-icon>inbox</mat-icon>
              </button>
            </mat-toolbar>
            <div class="row mt-3">
              <div class="col-lg-4 col-md-6 col-sm-12">
                <mat-form-field appearance="outline" color="accent" class="full-width">
                  <mat-label>Programme Type</mat-label>
                  <mat-select id="programmeType" required>
                    <mat-option>
                      Degree</mat-option>
                    <mat-option>
                      Diploma</mat-option>
                    <mat-option>
                      Certificate</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <mat-form-field appearance="outline" color="accent" class="full-width">
                  <mat-label>Programme Title</mat-label>
                  <mat-select id="programme" required>
                    <mat-option>
                      Jewellery Design Technology</mat-option>
                    <mat-option>
                      Product Design & Entrepreneurship</mat-option>
                    <mat-option>
                      Jewellery Design</mat-option>
                    <mat-option>
                      Product Design</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <mat-form-field appearance="outline" color="accent" class="full-width">
                  <mat-label>Application Status</mat-label>
                  <mat-select id="Status" required>
                    <mat-option>
                      Accepted</mat-option>
                    <mat-option>
                      Rejected</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <mat-form-field appearance="outline" color="accent" class="full-width">
                  <input matInput placeholder="To:">
                </mat-form-field>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <mat-form-field appearance="outline" color="accent" class="full-width">
                  <input matInput placeholder="Subject:">
                </mat-form-field>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="submit-button">
                  <button mat-button>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
